import { configureStore } from "@reduxjs/toolkit";
import filterReducer from "../features/filter/filterSlice.js";
import { apiSlice } from "./../features/api/apiSlice";
export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    filter: filterReducer,
  },
  middleware: (defaultMiddleware) => defaultMiddleware().concat(apiSlice.middleware),
});
